export const http = {
  METHOD_TYPE: {
    POST: 'POST',
    PUT: 'PUT',
    GET: 'GET',
    DELETE: 'DELETE',
  },
  CONTENT_TYPE: {
    APPLICATION_JSON: 'application/json',
    MULTIPART_FORM_DATA: 'multipart/form-data',
    APPLICATION_FORM_URLENCODED: 'application/x-www-form-urlencoded',
    IMAGE_PNG: 'image/png'
  },
  DEVICE_TYPE: {
    WEB: 'web'
  },
  API_END_POINT: {
    BASE: 'https://webapi.americanenglishacademy.edu.mx'
    // BASE: 'http://localhost:8002'
  },
};